import { Map, List } from 'immutable';

import { ActionTypes } from '../constants/AppConstants';
import BaseStore from './BaseStore';

class SmartcardJourneyStore extends BaseStore {

    getInitialState () {
        const journeys = new List();
        return new Map({ journeys });
    }

    hasJourneys () {
        return !this.state.get('journeys').isEmpty();
    }

    handleJourneysLoaded ({ journeys }) {
        this.setState(this.state.set('journeys', journeys));
    }

    byDay () {
        return this.get('journeys').groupBy((transaction) => transaction.dateTime.format('YYYY-MM-DD'));
    }

    getActionHandlers () {
        return {
            [ ActionTypes.SMARTCARD_JOURNEYS_LOADED ]: this.handleJourneysLoaded,
            [ ActionTypes.LOGGED_OUT ]: this.resetState
        };
    }

}

export default new SmartcardJourneyStore();
